module.exports = __webpack_public_path__ + "img/Comic_65.4bc04cec.png";